export const REGULAR_MEDIA_QUERY = '(min-width: 768px)';

export const WIDE_MEDIA_QUERY = '(min-width: 1280px)';
